import { Component, inject } from '@angular/core';
import { DepletionExchangeAmountService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DepletionExchangeAmountCreateDto,
  DepletionExchangeAmountDto,
  DepletionExchangeAmountExcelDownloadDto,
  DepletionExchangeAmountUpdateDto,
} from '../proxy/controlling/dtos/depletion-exchange-amount';
import { DEPLETIONEXCHANGEAMOUNT_CONFIG, DEPLETIONEXCHANGEAMOUNT_FIELDS } from './depletion-exchange-amount.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-depletion-exchange-amount',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DepletionExchangeAmountService, ConfirmationService],
  templateUrl: './depletion-exchange-amount.html',
  styleUrl: './depletion-exchange-amount.scss',
})
export class DepletionExchangeAmount extends BaseCrudComponent<
  DepletionExchangeAmountDto,
  DepletionExchangeAmountCreateDto,
  DepletionExchangeAmountUpdateDto,
  DepletionExchangeAmountExcelDownloadDto
> {
  service = inject(DepletionExchangeAmountService);
  config = DEPLETIONEXCHANGEAMOUNT_CONFIG;
  fields = DEPLETIONEXCHANGEAMOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: DepletionExchangeAmountDto): DepletionExchangeAmountUpdateDto {
    return {
      year: data.year,
      assetId: data.assetId,
      isOwnPlantation: data.isOwnPlantation,
      usdAmount: data.usdAmount,
      uyuAmount: data.uyuAmount,
      euroAmount: data.euroAmount,
      exchangeType: data.exchangeType,
      euroExchangeType: data.euroExchangeType,
      depletionTypeId: data.depletionTypeId,
      contractTypeId: data.contractTypeId,
      monthId: data.monthId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DepletionExchangeAmount';
  }
}
